import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Milestones.scss";

const milestones = [
  { year: "1989", text: "First Establishment." },
  { year: "2009", text: "Cleared Tenneco 1st Re Assessment Audit." },
  { year: "2011", text: "Awarded with Projections B515,H79." },
  { year: "2014", text: "Moved to 4000 Sq.Ft Rental Space." },
  { year: "2018", text: "Received LOI for 560B, VF35 & First Export Order to Tenneco Brazil." },
  { year: "2022", text: "First Shipment to Brazil/Shifting to new space 12000 Sq.Ft." },
  { year: "2024", text: "Expand M/c capacity for bigger components: Spring, Knuckle, Bracket etc." },
  { year: "2027", text: "Expand floor space further 4000 Sq.Ft available." },
];

const Milestones = () => {
  return (
    <section className="milestones container-fluid py-3">
      <h2 className="text-center section-title">Our Milestones</h2>

      <div className="timeline">
        {milestones.map((milestone, index) => (
          <div key={index} className={`timeline-item ${index % 2 === 0 ? "left" : "right"}`}>
            <div className="timeline-content">
              <h3 className="year">{milestone.year}</h3>
              <p className="description">{milestone.text}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Milestones;
